import ConversationCreatorActions from './conversation_creator';
import Router from '../utils/router';
import Graphql from '../utils/graphql';
import BrowserUtils from '../utils/browser';
import ConversationActionTypes from '../types/conversation';
import Q from 'q';

const ConversationActions = { types: ConversationActionTypes };

ConversationActions.selectConversation = function(conversation) {
  return {
    type: ConversationActions.types.SELECT_CONVERSATION,
    conversation: conversation
  };
};

ConversationActions.deselect = function() {
  return {
    type: ConversationActions.types.DESELECT_CONVERSATION
  };
};

ConversationActions.receiveAndReorder = function(data) {
  return {
    type: ConversationActions.types.REORDER,
    conversation: data
  };
}
;
ConversationActions.receiveAndReplace = function(data) {
  return {
    type: ConversationActions.types.REPLACE,
    conversation: data
  };
};

ConversationActions.receiveNewPage = function(data) {
  return {
    type: ConversationActions.types.RECEIVE_NEW_PAGE,
    conversations: data
  };
};

ConversationActions.remove = function(conversation) {
  return {
    type: ConversationActions.types.REMOVE,
    conversation: conversation
  };
};

ConversationActions.loadingActive = function(conversation) {
  return {
    type: ConversationActions.types.REQUESTING,
    conversation: conversation
  };
};

ConversationActions.error = function(error) {
  return {
    type: ConversationActions.types.ERROR,
    error: error
  };
};

ConversationActions.fetchActive = function (conversation, options) {
  return function(dispatch, getState) {
    return Q(dispatch(ConversationActions.markAsRead(conversation))).fin(() => {
      options || (options = {});

      return Q(Graphql.queryWithOperationName(
        'RoomsListAndActiveRoom',
        { id: conversation.id, ids: [conversation.id] }
      )).then((response) => {
        if (getState().activeConversation.id === response.activeConversation.id) {
          dispatch(ConversationActions.selectConversation(response.activeConversation));
        }

        if (options.reorder) {
          dispatch(ConversationActions.receiveAndReorder(response.conversations.edges[0]));
        } else {
          dispatch(ConversationActions.receiveAndReplace(response.conversations.edges[0]));
        }

        if (options.notify) {
          BrowserUtils.notifyNewMessage(response.conversations.edges[0].node);
        }
      }, jqXHR => {
        if (jqXHR.rawError) {
          dispatch(ConversationActions.notFound(jqXHR.rawError, jqXHR.rawData, conversation));
        }
      });
    });
  };
};

ConversationActions.fetchInactive = function (conversation, options) {
  return function(dispatch) {
    return Q(Graphql.queryWithOperationName(
      'RoomsList',
      { ids: [conversation.id] }
    )).then((response) => {
      window.updateNotificationCount();
      dispatch(ConversationActions.receiveAndReorder(response.conversations.edges[0]));

      if (options && options.notify) {
        BrowserUtils.notifyNewMessage(response.conversations.edges[0].node);
      }
    }, jqXHR => {
      if (jqXHR.rawError) {
        dispatch(ConversationActions.notFound(jqXHR.rawError, jqXHR.rawData, conversation));
      }
    });
  };
};

ConversationActions.fetchNewPage = function() {
  return function(dispatch, getState) {
    var state = getState();
    var afterCursor = state.conversations.edges[state.conversations.edges.length - 1].cursor;

    return Q(Graphql.queryWithOperationName(
      'RoomsList',
      { after: afterCursor }
    )).then((response) => {
      dispatch(ConversationActions.receiveNewPage(response.conversations));
    }, () => {
      $('body').trigger('flashmessage', ['danger', 'Unable to load next page']);
    });
  };
};

ConversationActions.markAsRead = function(conversation) {
  return function() {
    var url = conversation.markAsReadLink ? conversation.markAsReadLink
      : '/conversations/' + conversation.id + '/read.json';

    return Q($.ajax({
      url: url,
      type: 'PUT',
      dataType: 'text'
    })).then(() => {
      window.updateNotificationCount();
    });
  };
};

ConversationActions.archive = function (conversationId) {
  return function(dispatch, getState) {
    var state = getState();
    var conversation = state.conversations.edges.find(conversation => {
      return conversation.node.id === conversationId;
    });
    var url = conversation.node.archiveLink;
    var active = state.activeConversation.id === conversation.node.id;

    return Q($.ajax({
      url: url,
      type: 'PUT',
      dataType: 'text'
    })).then(() => {
      dispatch(ConversationActions.remove(conversation.node));
      if (active) {
        dispatch(ConversationActions.selectUnload());
      }
    });
  };
};

ConversationActions.selectLoad = function(conversation) {
  return function(dispatch) {
    if (dispatch(ConversationCreatorActions.close())) {
      dispatch(ConversationActions.loadingActive(conversation));
      dispatch(ConversationActions.fetchActive(conversation));

      Router.transitionTo('/conversations/:id/messages', { id: conversation.id });
    }
  };
};

ConversationActions.selectUnload = function() {
  return function(dispatch) {
    dispatch(ConversationActions.deselect());
    Router.transitionTo('/conversations');
  };
};

ConversationActions.notFound = function(errors, data, conversation) {
  return function(dispatch, getState) {
    errors.forEach(error => {
      if (!error.path) {
        dispatch(ConversationActions.error(error));
        return;
      }

      switch (error.path[0]) {
        case 'activeConversation':
          dispatch(ConversationActions.error(error));
          Router.transitionTo('/conversations');
          break;
        case 'conversations':
          dispatch(ConversationActions.remove(conversation));
          break;
      }
    });

    if (data.activeConversation && getState().activeConversation.id === data.activeConversation.id) {
      dispatch(ConversationActions.selectConversation(data.activeConversation));
    }

    $('body').trigger('flashmessage', ['danger', 'Unable to load conversation']);
    window.updateNotificationCount();
  };
};

export default ConversationActions;
